import colors from 'vuetify/lib/util/colors'
import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum LoginUserStates {
    DRAFT = 'draft',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export namespace LoginUserStates {
    type Data = {
        text: string;
        color: string;
    };

    export const Record: Record<LoginUserStates, Data> = {
        [LoginUserStates.DRAFT]: {
            text: 'Entwurf',
            color: colors.grey.base,
        },
        [LoginUserStates.ACTIVE]: {
            text: 'Aktiv',
            color: 'success',
        },
        [LoginUserStates.INACTIVE]: {
            text: 'Gesperrt',
            color: 'error',
        },
    }

    export const Items = mapRecordToItems(Record);
}
